// extracted by mini-css-extract-plugin
export default {"modal":"u0LGi","title":"JowPu","text":"LNXVR","button":"QGDe4"};